module.exports = __webpack_public_path__ + "static/media/jam-choco.c2c8fcc4.png";